import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { webOauth } from "../../../config/auth";
import BackgroundImageFromUrl from "../../../components/parseImage/BackgroundImageFromUrl";

const OAuthCallBack = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  var backgroundImage = {
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
  };

  const handleClose = () => {
    setError("");
    cookies.remove("token");
    navigate("/login");
  };

  useEffect(() => {
    const hash = window.location.hash; // Lấy phần sau dấu #
    const params = new URLSearchParams(hash.replace("#", "")); // Xóa dấu #

    const accessToken = params.get("access_token");
    const fetchWebOAuth = async (accessToken) => {
      try {
        setIsLoading(true);
        const result = await webOauth( { accessToken, platform: 2 });
        var expires = 7 * 24 * 3600;
        if (cookies.get("signinUser")) {
          cookies.remove("signinUser");
        }
        cookies.set("signinUser", result?.access_token, {
          path: "/",
          maxAge: expires,
        });
        navigate("/");
      } catch (err) {
        navigate("/error");
      } finally {
        setIsLoading(false);
      }
    };
    if (accessToken) {
      fetchWebOAuth(accessToken);
    } else {
      setError("Không tìm thấy access_token");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);
  return (
    <BackgroundImageFromUrl
      objectId="admin/frontend-images/auth/bg-desktop-signin.svg"
      className=""
      style={backgroundImage}
    >
      <div
        className="columns m-0 p-0 is-justify-content-center is-align-content-flex-start"
        style={{ minHeight: "100vh", width: "100%" }}
      >
        {isLoading && (
          <>
            <div className="column m-0 p-0 is-relative">
              <div
                style={{
                  width: "15rem",
                  margin: "24.4375rem 0 0 5rem",
                }}
              >
                <p
                  style={{ fontSize: "1.125rem" }}
                  className="mb-4 has-text-kurio-main-color-white is-uppercase"
                >
                  Đang tải
                </p>
                <span
                  className="loader__quiz"
                  style={{ width: "15rem" }}
                ></span>
              </div>
              <div
                style={{
                  width: "21.5rem",
                  height: "8.3125rem",
                  backgroundImage: "url('/images/auth/logo-signin.svg')",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  position: "absolute",
                  left: "0",
                  bottom: "0",
                }}
              ></div>
            </div>
            <BackgroundImageFromUrl
              objectId="admin/frontend-images/auth/image-left-signin.svg"
              style={{
                width: "42.9375rem",
                height: "47rem",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                marginRight: "8.375rem",
              }}
            ></BackgroundImageFromUrl>
            <div
              style={{
                height: "7.5rem",
                width: "7.443125rem",
                position: "absolute",
                bottom: "5.625rem",
                right: "6rem",
                // transform: "rotate(2deg)",
                backgroundImage:
                  "url('/images/auth/floating-element-signin.svg')",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            ></div>
          </>
        )}
      </div>
      <div>
        {error && error?.length > 0 && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.25)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={handleClose}
          >
            <div
              style={{
                border: "1px solid #fbc02d",
                borderRadius: 10,
                padding: 24,
                minWidth: 340,
                maxWidth: 480,
                boxShadow: "0 4px 32px #0002",
                position: "relative",
                maxHeight: "70vh",
                overflowY: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="has-text-kurio-red-light-3"
                onClick={handleClose}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 14,
                  background: "none",
                  border: "none",
                  fontSize: 22,
                  cursor: "pointer",
                }}
                title="Close"
              >
                ×
              </button>
              <div
                className="has-text-kurio-red"
                style={{
                  fontWeight: 700,
                  marginBottom: 12,
                  fontSize: 18,
                }}
              >
                Error
              </div>
              <div>
                <p>{error}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </BackgroundImageFromUrl>
  );
};

export default OAuthCallBack;
